// clampSceneIdxToZeroIndexed — extrahiert aus
// public/src/lib/url/clampSceneIdx.ts (Plan A Mapping-Audit 2026-05-22).
//
// Plan-1.9 Phase 3.B.CP2 — Scene-Index-Konvertierung & Boundary-Clamp.
// Brücke zwischen URL-Schema (1-indexed `#scene-N`) und Renderer-API
// (0-indexed `slidePositions[N]` / `goToSlide(N)`).

/**
 * Konvertiert einen 1-indexed URL-Scene-Index zur 0-indexed
 * Renderer-Scene-Position und clampt gegen `slideCount`.
 *
 * @param oneIndexed 1-indexed Wert aus URL. undefined ist erlaubt
 *                    (kein Anchor → null returnt).
 * @param slideCount Anzahl Slides im Scrolly (`store.slideCount`).
 *                    Bei 0 (z.B. vor Layout-Settle) liefern wir null.
 * @returns 0-indexed Scene-Index für `goToSlide()`, oder null wenn
 *          kein valider Aufruf möglich ist.
 */
export function clampSceneIdxToZeroIndexed(
  oneIndexed: number | undefined | null,
  slideCount: number,
): number | null {
  if (typeof oneIndexed !== "number" || !Number.isFinite(oneIndexed)) {
    return null;
  }
  if (oneIndexed < 1) return null;
  if (slideCount <= 0) return null;
  const internalIdx = oneIndexed - 1;
  return Math.min(internalIdx, slideCount - 1);
}
